import type { ChatHistoryItem } from '~/lib/persistence/useChatHistory';

/**
 * Overlays the live AI-generated title onto the active chat's row. Matches by
 * id OR urlId (chat rows are reachable by either), and only fills BLANK
 * descriptions — a title the user typed themselves is never overwritten.
 */
export function overlayLiveTitle(
  list: ChatHistoryItem[],
  activeChatId: string | null,
  title: string,
): ChatHistoryItem[] {
  if (!activeChatId || !title) {
    return list;
  }

  return list.map((c) =>
    (c.id === activeChatId || c.urlId === activeChatId) && !c.description ? { ...c, description: title } : c,
  );
}
